// import Cardinho from "../styledComponents/styledComponents";
import { CardinhoNovo } from "../styledComponents/styledComponents";

function CardinhoComp({ obj, state, setState, deleteCard }) {
  return (
    <CardinhoNovo>
      <span>
        <img src={obj.img} alt="" />
      </span>

      <section>
        <h3>{obj.name}</h3>
        <p>{obj.category}</p>
      </section>

      <button
        onClick={() => {
          deleteCard(obj, state.state, state.setState);
        }}
      >
        Remover
      </button>
    </CardinhoNovo>
  );
}

export default CardinhoComp;
